module.exports = __webpack_public_path__ + "img/v.d95d9395.svg";